import lookup from "./lookup.store";
import department from "./department.store";
import attachment from "./attachment.store";
import province from "./province.store";
import amphur from "./amphur.store";
import tambon from "./tambon.store";
import address from "./address.store";
import jobPosition from "./job-position.store";
import hazSubStance from "./haz-sub-stance.store";
import hazObject from "./haz-object.store";
import hazObjectCoordinate from "./haz-object-coordinate.store";
import coordinateCustoms from "./coordinate-customs.store";
import ld50 from "./ld50.store";
import pictogram from "./pictogram.store";
import feeRate from "./fee-rate.store";
import requestDepartment from "./request-department.store";
import country from "./country.store";
import customs from "./customs.store";
import departmentCustoms from "./department-customs.store";
import feeRateExcludeCountry from "./fee-rate-exclude-country.store";
import feeRateExcludeDepartment from "./fee-rate-exclude-department.store";
import feeRateExcludeOperation from "./fee-rate-exclude-operation.store";
import feeRateExcludeProduct from "./fee-rate-exclude-product.store";
import feeRateExcludeUser from "./fee-rate-exclude-user.store";
import hazDiscussCase from "./haz-discuss-case.store";
import discussCaseDetail from "./discuss-case-detail.store";
import discussCaseSubStance from "./discuss-case-sub-stance.store";
import inspectionRisk from "./inspection-risk.store";
import inspectionRiskTopic from "./inspection-risk-topic.store";
import riskTopic from "./risk-topic.store";
import riskTopicCondition from "./risk-topic-condition.store";
import userRedAccount from "./user-red-account.store";
import signJobPosition from "./sign-job-position.store";
import signJobPositionDetail from "./sign-job-position-detail.store";

export default {
    lookup,
    department,
    attachment,
    province,
    amphur,
    tambon,
    address,
    jobPosition,
    hazSubStance,
    hazObject,
    coordinateCustoms,
    hazObjectCoordinate,
    ld50,
    pictogram,
    feeRate,
    requestDepartment,
    country,
    customs,
    departmentCustoms,
    feeRateExcludeCountry,
    feeRateExcludeDepartment,
    feeRateExcludeOperation,
    feeRateExcludeProduct,
    feeRateExcludeUser,
    hazDiscussCase,
    discussCaseDetail,
    discussCaseSubStance,
    inspectionRisk,
    inspectionRiskTopic,
    riskTopic,
    riskTopicCondition,
    userRedAccount,
    signJobPosition,
    signJobPositionDetail
};
